import React, { useEffect } from 'react';
import CareersHero from '../components/careerspage/Hero';
import WhyJoinUs from '../components/careerspage/WhyJoinUs';
import OpenPositions from '../components/careerspage/OpenPositions';


const CareersPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  return (
    <div className="min-h-screen bg-white">
      <CareersHero />
      <OpenPositions />
      <WhyJoinUs />
      {/* <EmployeeBenefits /> */}
    </div>
  );
};

export default CareersPage;